import get from 'lodash/get';
import * as types from './constants';

const defaultState = {
  loading: false,
  error: null,
  documentError: null,
  activeStep: 0,
  application: {},
  documents: [],
  breakdown: {},
  applicationId: null,
  professionType: '',
  professionTypes: [],
  professionClassifications: [],
  surveyingEmployees: [],
  surveyingCompanyTypes: [],
  thinkPropCertifiedDetails: {},
  thinkPropCertified: false,
  thinkPropState: {
    loading: false,
    error: null,
  },
  additionalInfo: {
    company_name: '',
    area_of_expertise: '',
    municipality: '',
    professionClassificationId: '',
  },
  expertDetails: {
    issue_date: undefined,
    end_date: undefined,
    reference_number: '',
  },
  uploadDocuments: [],
  deletedDocuments: [],
  inputError: {},
};

export default function ProfessionRegistrationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.PROFESSION_REGISTRATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.PROFESSION_REGISTRATION_VERIFIED_ERROR:
      return {
        ...state,
        thinkPropState: {
          ...state.thinkPropState,
          error: action.payload,
          loading: false,
        },
      };
    case types.PROFESSION_REGISTRATION_VERIFIED_LOADING:
      return {
        ...state,
        thinkPropState: {
          ...state.thinkPropState,
          error: undefined,
          loading: true,
        },
      };
    case types.PROFESSION_REGISTRATION_VERIFIED_SUCCESS:
      return {
        ...state,
        thinkPropState: {
          ...state.thinkPropState,
          loading: false,
        },
        thinkPropCertified: true,
        thinkPropCertifiedDetails: get(action.payload, 'data', {}),
      };
    case types.PROFESSION_REGISTRATION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        dataError: null,
        inputError: {},
      };

    case types.SET_PROFESSION_TYPES:
      return {
        ...state,
        professionTypes: get(action.payload, 'professionTypes', state.professionTypes),
        professionType: get(action.payload, 'professionType', ''),
        loading: false,
      };
    case types.UPDATE_PROFESSION_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case types.FETCH_APPLICATION_PROFESSION_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        additionalInfo: get(action.payload, 'additionalInfo', {}),
        thinkPropCertified: get(action.payload, 'thinkPropCertified', false),
        thinkPropCertifiedDetails: get(action.payload, 'thinkPropCertifiedDetails', {}),
      };
    case types.FETCH_DOCUMENTS_PROFESSION_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
        uploadDocuments: get(action.payload, 'uploadDocuments', []),
        expertDetails: get(action.payload, 'expertDetails', state.expertDetails),
      };

    case types.INITIATE_PROFESSION_REGISTRATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
      };

    case types.CHANGE_PROFESSION_REGISTRATION_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.DOWNLOAD_DOCUMENT_PROFESSION_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.CHECKOUT_PROFESSION_REGISTRATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.PROFESSION_REGISTRATION_CANCEL_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.PROFESSION_REGISTRATION_CLEAR_DATA:
      return defaultState;

    case types.SAVE_APPLICATION_PROFESSION_REGISTRATION_SUCCESS:
      return {
        ...state,
        application: action.payload ?? state.application,
        loading: false,
        error: null,
      };

    case types.UPLOAD_PROFESSION_REGISTRATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        documentError: action.payload,
      };
    default:
      return state;
  }
}
